import { handleAxiosError } from "../common/handleAxiosError";
import { projectsApiClient } from "../common/axiosInstanceProjects";
import { ISectionFormData } from "./types";

interface IUpdateSection {
  sectionId: number;
  formData: ISectionFormData;
}

export const updateSection = async ({ sectionId, formData }: IUpdateSection) => {
  try {
    const data = await projectsApiClient.put(`/sections/${sectionId}`, formData)
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al crear el proyecto");
  }
};
